module.exports = __webpack_public_path__ + "img/75600.d9684a4b.jpg";